export default __webpack_public_path__ + "static/beige-nr-black-bananatex-d380a1bc52c85ecfa759d95db6b9d058.png";